import {isNotNil} from 'ramda';

import {
  VehicleFinancingBalloonPayment,
  VehicleFinancingTemplateResponseBody,
  VehicleFinancingTerm,
} from '@dms/api/sales';

import {Nullish} from 'shared/web';

import {RateMatrixValue} from '../types/RateMatrixValue';
import {deserializeRateMatrix} from './deserializeRateMatrix';

const DEFAULT_AVAILABLE_TERMS: VehicleFinancingTerm[] = [12, 24, 36, 48, 60, 72, 84];

export const INITIAL_BALLOON_BRACKET: VehicleFinancingBalloonPayment = 10;

export function getInitialRateMatrixValue(
  template: VehicleFinancingTemplateResponseBody | Nullish
): RateMatrixValue {
  if (isNotNil(template)) {
    return deserializeRateMatrix(template.rateMatrix, template.defaultBalloonPayment);
  }

  return {
    availableTerms: [...DEFAULT_AVAILABLE_TERMS],
    cells: {},
    availableBalloonBrackets: [INITIAL_BALLOON_BRACKET],
    defaultBalloonPayment: INITIAL_BALLOON_BRACKET,
  };
}
